import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { ExceptionLogListModel,ExceptionLogListRequestModel } from '../business-entities/exception-log-model';

@Injectable({
    providedIn: 'root'
})
export class ExceptionLogDataService {
    constructor(private dataProvider: DataService) { }

    GetErrorLogs(errorLogRequestModel: ExceptionLogListRequestModel): Promise<GenericResponse<ExceptionLogListModel>> {
        return this.dataProvider.Post<GenericResponse<ExceptionLogListModel>>(Urls.GetSmartPlannerExceptionLog, errorLogRequestModel).toPromise();
    }
}